import { Stack, useLocalSearchParams } from "expo-router";
import { HeaderButton } from "~/components/HeaderButton";
import { ClinicalDocument } from "~/components/layout/health-profile/ClinicalDocument";
import { Authorize } from "~/components/permission/Authorize";
import { Can } from "~/components/permission/Can";
import { Dismiss } from "~/components/permission/Dismiss";
import { useGallery } from "~/providers/GalleryProvider";

export default function AllergyDetails() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findDocument } = useGallery();

    const item = findDocument(id);

    if (!item) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="view" section="documents">
            <Stack.Screen
                options={{
                    title: "Document details",
                    headerRight: () => (
                        <Can ability="update" section="documents">
                            <HeaderButton
                                title="Edit"
                                href={{ pathname: "/health-profile/clinical-documents/[id]/edit", params: { id } }}
                            />
                        </Can>
                    ),
                }}
            />
            <ClinicalDocument item={item} />
        </Authorize>
    );
}
